import React, { useEffect, useState } from 'react'

import { Attr, AttrName } from './styled'

import { getVersion, deleteVersion } from '../../../services/terms/service'
import { useDispatch, useSelector } from 'react-redux';
import { startRequest, finishRequest } from '../../../store/modules/loading/actions';

import history from '../../../services/history';
import ContentPanel from '../../../components/ContentPanel';
import { ButtonContainer, Button } from '../../../styles/components';
import { setMessage } from '../../../store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';

export default function Terms({match}) {
  const termsId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [terms, setTerms] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(startRequest());
    getVersion(termsId).then(data => {
      setTerms(data.data);
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }, [dispatch, termsId])

  async function handleDelete () {
    dispatch(startRequest());
    deleteVersion(termsId).then(data => {
      history.push('/terms')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir o termo?" message={message}>
        {terms && <>
          <AttrName>URL:</AttrName>
          <Attr>{terms.url}</Attr>
          <AttrName>Notas:</AttrName>
          <Attr>{terms.notes}</Attr>

          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}